export default (type, colors) => {
  const styles = {
    type1: {
      'c-inline-search': {
        customCSS: `
          .c-inline-search {
            margin-left: 0;
            margin-right: 0;
          }
          @media screen and (min-width: 64em) {
            .c-inline-search {
              margin-left: -10.333%;
              margin-right: -10.333%;
            }
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cInlineSearch.js